import Axios from '../plugins/axios'

export const fetchFloors = function () {
    return Axios.get('floors?lang=bg')
}

export const removeFloor = function (id) {
    return Axios.delete('floors/' + id)
}

export const createFloor = function (entrance) {
    return Axios.post('floors', entrance)
}

export const fetchFloor = function (id) {
    return Axios.get(`floors/${id}?lang=bg`)
}

export const updateFloor = function (id, floor) {
    return Axios.put(`floors/${id}`, floor)
}